// /src/components/CategoryList.tsx
import React from 'react';
import { Category } from '../utils/types';
import CategoryItem from './CategoryItem';

interface CategoryListProps {
    categories: Category[];
    onSelectCategory: (category: Category) => void;
    selectedCategories: Category[];
}

const CategoryList: React.FC<CategoryListProps> = ({ categories, onSelectCategory, selectedCategories }) => {
    // Filter for top-level categories (cat_parent is null or undefined)
    const topLevelCategories = categories
        .filter(cat => cat.cat_parent === null || cat.cat_parent === undefined)
        .sort((a, b) => a.cat_name.localeCompare(b.cat_name)); // Sort alphabetically

    return (
        <ul className='fixed top-10 md:top-10 left-0 z-20 bg-orange-100 w-11/12 md:w-3/4 h-[100vh] mt-0  text-gray-700 text-[0.8em] md:text-[1em] shadow-xl rounded-b-lg
         overflow-y-scroll pt-4 pl-2 pb-36
         '>
            {topLevelCategories.map(category => (
                <CategoryItem
                    key={category.id}
                    category={category}
                    onSelectCategory={onSelectCategory}
                    selectedCategories={selectedCategories}
                    allCategories={categories}
                    level={0}
                />
            ))}
        </ul>
    );
};

export default CategoryList;
